import { connect } from 'react-redux';

import { Tooltip } from 'UIPackage/MainModule/components/Tooltip';
import { DATE_FORMAT_LONG_MINUTE_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { getAccountOrganizationsData } from 'CorePackage/AccountModule/selectors/accountSelectors';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { IUserOrganisation } from 'APIPackage/AccountModule/interfaces/IUserOrganisation';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import styles from './HeaderInfo.module.scss';

interface IHeaderInfoProps {
  formedDate?: string;
}

interface IHeaderInfoStoreProps {
  prosecutorOrganisations: IUserOrganisation[];
}

const HeaderInfoWithoutStore = ({ formedDate, prosecutorOrganisations }: IHeaderInfoProps & IHeaderInfoStoreProps) => {
  let label = null;

  if (prosecutorOrganisations && prosecutorOrganisations.length > 0) {
    label = prosecutorOrganisations.filter(item => item.byDefault)[0]?.fullName;
  }

  const labelAttributes = {
    ...(formedDate && { 'data-bold': true }),
  };

  return (
    <>
      <div className={styles.HeaderInfo}>
        {label && (
          <div className={styles.Content}>
            <div className={styles.Label} {...labelAttributes}>
              {label}
            </div>
            <div className={styles.TooltipWrapper}>
              <Tooltip
                overlayClassName={styles.Tooltip}
                placement="bottom"
                content={
                  <div className={styles.TooltipContent}>
                    Изменение органа прокуратуры осуществляется в Личном кабинете
                  </div>
                }
              >
                <span className={styles.TooltipIcon} />
              </Tooltip>
            </div>
            {formedDate && (
              <div>
                Данные сформированы&nbsp;
                {formatDate({
                  date: formedDate,
                  dateFormat: DATE_FORMAT_LONG_MINUTE_FNS,
                  parseFormat: DATE_FORMAT_LONG_MINUTE_FNS,
                })}
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state: IRootState): IHeaderInfoStoreProps => ({
  prosecutorOrganisations: getAccountOrganizationsData(state).prosecutor,
});

export const HeaderInfo = connect(mapStateToProps)(HeaderInfoWithoutStore);
